import { render, staticRenderFns } from "./wHasmanyListed.vue?vue&type=template&id=0f07df48&scoped=true&"
import script from "./wHasmanyListed.vue?vue&type=script&lang=js&"
export * from "./wHasmanyListed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07df48",
  null
  
)

export default component.exports